'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Popover = require('./Popover');

var _Popover2 = _interopRequireDefault(_Popover);

var _typography = require('./styles/typography');

var _colors = require('./styles/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }

var DropDown = function DropDown(_ref) {
    var children = _ref.children,
        isOpen = _ref.isOpen,
        onRequestClose = _ref.onRequestClose,
        _ref$style = _ref.style,
        style = _ref$style === undefined ? {} : _ref$style;
    var popover = style.popover,
        link = style.link,
        hover = style.hover,
        container = style.container,
        offset = style.offset,
        attachment = style.attachment,
        targetAttachment = style.targetAttachment;

    var popoverStyle = _extends({
        padding: '7px 0px',
        width: 170
    }, popover);

    var linkStyle = _extends({}, _typography.text, _typography.large, _typography.truncate, {
        display: 'block',
        height: 40,
        lineHeight: '40px',
        padding: '0 18px',
        color: _colors.graphite
    }, link);

    var hoverStyle = _extends({
        background: _colors.offwhite
    }, hover);

    var containerStyle = _extends({
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'flex-end'
    }, container);

    var _children = _toArray(children),
        firstChild = _children[0],
        rest = _children.slice(1);

    return _react2.default.createElement(
        _Popover2.default,
        {
            attachment: attachment || 'top right',
            targetAttachment: targetAttachment || 'bottom right',
            targetOffset: offset || '0 0',
            hideCloseButton: true,
            isOpen: isOpen,
            onRequestClose: onRequestClose,
            style: popoverStyle
        },
        (0, _react.cloneElement)(firstChild, { style: containerStyle }),
        rest.map(function (child, index) {
            return (0, _react.cloneElement)(child, {
                key: index,
                style: linkStyle,
                hoverStyle: hoverStyle
            });
        })
    );
};

exports.default = DropDown;
//# sourceMappingURL=DropDown.js.map